// extracted by mini-css-extract-plugin
export var label = "_ri-0";
export var link = "_ri-1";